import React, { FC } from 'react';
import PropTypes from 'prop-types';
import AYLogo from '../assets/img/logo193.png';

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return <img src={AYLogo} alt='Logo' height='45'></img>;
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
